/* Native cart wallets become available only after the existing add and cart checks. */
(function (win) {
  'use strict';
  function validCart(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.length && Number(cart.total_price) > 0 && cart.items.every(function (item) {
      return item.handle !== 'fully-custom-order' && Number(item.final_price) > 0 && Number.isInteger(Number(item.quantity)) && Number(item.quantity) > 0;
    }));
  }
  function discountApplications(cart) {
    var applications = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) { if (allocation.discount_application) applications.push(allocation.discount_application); });
    });
    return applications;
  }
  function discountCodes(cart) {
    var result = [];
    function add(code, applicable) {
      code = String(code || '').trim();
      // Retired, rejected codes can persist in Shopify carts after a campaign ends.
      if (!applicable && code.toLowerCase() === 'watan96') return;
      if (!code || result.some(function (entry) { return entry.code.toLowerCase() === code.toLowerCase(); })) return;
      result.push({ code: code, applicable: applicable });
    }
    (cart.discount_codes || []).forEach(function (entry) { add(entry.code, entry.applicable === true); });
    discountApplications(cart).forEach(function (entry) { if (entry.type === 'discount_code') add(entry.title, true); });
    return result;
  }
  function promoCodesAfter(cart, code, action) {
    var codes = discountCodes(cart).filter(function (entry) { return entry.code.toLowerCase() !== code.toLowerCase(); }).map(function (entry) { return entry.code; });
    if (action !== 'remove') codes.push(code);
    return codes.join(',');
  }
  function codeSignature(cart) { return JSON.stringify(discountCodes(cart).map(function (entry) { return [entry.code.toLowerCase(), entry.applicable]; }).sort()); }
  function signature(cart) {
    return JSON.stringify({ total: cart.total_price, currency: cart.currency || '', discounts: discountApplications(cart).map(function (entry) { return [String(entry.type || ''), entry.title, Number(entry.total_allocated_amount || 0)]; }).sort(), items: (cart.items || []).map(function (item) {
      return [String(item.variant_id || item.id), Number(item.quantity), Number(item.final_price), Object.keys(item.properties || {}).sort().map(function (key) { return [key, item.properties[key]]; })];
    }).sort(function (a, b) { return JSON.stringify(a).localeCompare(JSON.stringify(b)); }) });
  }
  function propertySignature(item, native) {
    var properties = item.properties || {};
    if (native && typeof native.contextForItem === 'function' && typeof native.translate === 'function') {
      var context = native.contextForItem(item);
      // The native translator validates its metadata before restoring source labels.
      // Unknown options, uploads, and internal DPO properties remain exact.
      if (context) properties = native.translate(properties, 'en', context);
    }
    return JSON.stringify(Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; }));
  }
  function matchesAdded(cart, added, native) {
    native = native || (win && win.KlikNativeDpoProperties);
    var items = added && (added.items || [added]);
    return !!(items && items.length && items.every(function (addedItem) {
      return (cart.items || []).some(function (item) {
        return String(item.variant_id || item.id) === String(addedItem.variant_id || addedItem.id) && Number(item.quantity) >= Number(addedItem.quantity || 1) && Number(item.final_price) > 0 && propertySignature(item, native) === propertySignature(addedItem, native);
      });
    }));
  }
  // Cart JSON and its rendered review are independent reads after native options settle.
  // Keep the final cart comparison before enabling any payment control.
  function reviewReads(sync, read, render) {
    return Promise.resolve().then(sync).then(function () { return Promise.all([read(), render()]); });
  }
  var api = { reviewReads: reviewReads, validCart: validCart, signature: signature, matchesAdded: matchesAdded, discountCodes: discountCodes, promoCodesAfter: promoCodesAfter };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!win || !win.document) return;
  if (win.KlikExpressCheckout) return;
  win.KlikExpressCheckout = api;
  // PACKAGES §1.13 (owner, 2026-10-21): no express payment on product pages and one primary per studio step, so the
  // "Continue to payment" entry is no longer mounted in the studio review steps (ready, sofa, furniture and DPO wizards).
  // Their own Add to cart stays the one action; completeNativeOrder/Set then return false and each caller keeps its usual
  // add path. Set to true to bring the entry back.
  var PDP_PAYMENT_ENTRY = false;
  var doc = win.document, pendingAdd = null, refreshing = null, refreshQueued = false, generation = 0, verified = false, refreshTimer;
  var dialog, body, status, fallback, panelSignature = null, panelCart = null, panelRequest = 0, panelAbort = null, returnTarget = null, returnSource = null, promoPending = null;
  var nativeSaved = new WeakMap(), entrySaved = new WeakMap();
  var cartPromoNotice = null, cartPromoNoticeKey = 'klik.cart.promo-result.v1';
  function t(en, ar) { return /^ar\b/i.test(doc.documentElement.lang || '') ? ar : en; }
  function root() { return (win.Shopify && win.Shopify.routes && win.Shopify.routes.root || '/').replace(/\/?$/, '/'); }
  function message(en, ar) { if (status) status.textContent = t(en, ar); }
  function storefront(url) { return typeof win.KlikStorefrontURL === 'function' ? win.KlikStorefrontURL(url) : url; }
  function request(url, accept, signal, payload) {
    var abort = new AbortController(), timer = win.setTimeout(function () { abort.abort(); }, 15000);
    var cancel = function () { abort.abort(); };
    if (signal) { if (signal.aborted) cancel(); else signal.addEventListener('abort', cancel, { once: true }); }
    var options = { credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: { Accept: accept || 'application/json' } };
    if (payload) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
    return win.fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response;
    }).finally(function () { win.clearTimeout(timer); if (signal) signal.removeEventListener('abort', cancel); });
  }
  // v2 (PF-17): one shared cart read (window.KlikCart, klik-cart-store.js); the direct request stays as the fallback.
  function readCart(signal) {
    if (win.KlikCart && typeof win.KlikCart.get === 'function') return win.KlikCart.get();
    return request(root() + 'cart.js', null, signal).then(function (response) { return response.json(); });
  }
  var intentKey = 'klik.express.native-intent.v1';
  function clearIntent() { try { win.sessionStorage.removeItem(intentKey); } catch (_) {} }
  function quantityFor(cart, productId) {
    return (cart.items || []).filter(function (item) { return String(item.product_id) === String(productId); }).reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
  }
  function rememberNativeIntent(section, cart) {
    var productId = section.getAttribute('data-product-id');
    if (!/^\d+$/.test(productId || '')) return;
    try { win.sessionStorage.setItem(intentKey, JSON.stringify({ productId: productId, quantity: quantityFor(cart, productId), at: Date.now() })); } catch (_) {}
  }
  function resumeNativeIntent() {
    if (!/\/cart\/?$/.test(win.location.pathname)) return;
    var intent;
    try { intent = JSON.parse(win.sessionStorage.getItem(intentKey)); } catch (_) {}
    clearIntent();
    if (!intent || !/^\d+$/.test(intent.productId || '') || !Number.isInteger(intent.quantity) || intent.quantity < 0 || !Number.isFinite(intent.at) || Date.now() - intent.at < 0 || Date.now() - intent.at > 120000) return;
    syncAndRead().then(function (cart) {
      if (validCart(cart) && quantityFor(cart, intent.productId) > intent.quantity) paymentPanel();
    }).catch(function () {});
  }
  function termsAccepted(form) { var box = form && form.querySelector('.cart__terms-checkbox'); return !box || box.checked; }
  function setWallets() {
    doc.querySelectorAll('[data-klik-express-wallets]').forEach(function (wallets) {
      // Shopify owns wallet eligibility inside its native closed shadow root.
      var visible = verified && !promoPending && termsAccepted(wallets.closest('form'));
      wallets.hidden = !visible; wallets.inert = !visible;
    });
    if (body) body.querySelectorAll('[data-klik-express-standard]').forEach(function (button) { button.disabled = !verified || !!promoPending || !termsAccepted(button.form); });
  }
  function invalidate() { verified = false; generation += 1; setWallets(); }
  function currentNote(cart) {
    return Array.from(doc.querySelectorAll('#CartDrawerForm textarea[name="note"], #CartPageForm textarea[name="note"]')).filter(function (input) { return input.getClientRects().length; }).every(function (input) { return input.value === (cart.note || ''); });
  }
  function syncAndRead(signal) {
    var native = win.KlikNativeDpoProperties;
    return (native && typeof native.syncCart === 'function' ? native.syncCart() : Promise.resolve()).then(function () { return readCart(signal); });
  }
  function refresh() {
    if (refreshing) { refreshQueued = true; return refreshing; }
    refreshQueued = false;
    var revision = generation;
    refreshing = syncAndRead().then(function (cart) {
      if (revision !== generation) { refreshQueued = true; return; }
      verified = !promoPending && validCart(cart) && currentNote(cart);
      if (dialog && dialog.open) {
        if (!panelSignature) verified = false;
        else if (signature(cart) !== panelSignature || (panelCart && codeSignature(cart) !== codeSignature(panelCart))) {
          verified = false; fallback.hidden = false;
          message('Your cart changed. Open it to review the updated items and total before payment.', 'تغيرت سلتك. افتحها لمراجعة القطع والإجمالي المحدّث قبل الدفع.');
        }
      }
      setWallets();
      if (!promoPending) renderCartPromos(cart);
      return cart;
    }).catch(function () { verified = false; setWallets(); }).finally(function () {
      refreshing = null;
      if (refreshQueued) { refreshQueued = false; win.clearTimeout(refreshTimer); refreshTimer = win.setTimeout(refresh, 0); }
    });
    return refreshing;
  }
  function scheduleRefresh() {
    invalidate(); win.clearTimeout(refreshTimer);
    refreshTimer = win.setTimeout(function () { refresh().then(function (cart) { if (cart && !currentNote(cart)) refreshTimer = win.setTimeout(refresh, 1000); }); }, 350);
  }
  function resetPending() {
    if (!pendingAdd) return;
    clearIntent();
    win.clearTimeout(pendingAdd.timer);
    pendingAdd.button.disabled = false;
    pendingAdd.button.removeAttribute('aria-busy');
    pendingAdd = null;
  }
  function expectedItems(added) {
    var items = added && (added.items || [added]);
    return items && items.length ? JSON.parse(JSON.stringify(items)) : null;
  }
  function sameLine(a, b) {
    return String(a.variant_id || a.id) === String(b.variant_id || b.id) && propertySignature(a, win.KlikNativeDpoProperties) === propertySignature(b, win.KlikNativeDpoProperties);
  }
  function addedSince(pending, cart) {
    if (!pending || !pending.before || !pending.productId) return null;
    var items = [];
    (cart.items || []).filter(function (item) { return String(item.product_id) === pending.productId; }).forEach(function (item) {
      var before = pending.before.items.filter(function (old) { return sameLine(old, item); }).reduce(function (quantity, old) { return quantity + Number(old.quantity); }, 0);
      var quantity = Number(item.quantity) - before;
      if (quantity > 0) { var copy = JSON.parse(JSON.stringify(item)); copy.quantity = quantity; items.push(copy); }
    });
    return items.length ? items : null;
  }
  function savedFor(pending) {
    var saved = pending.configurationKey ? nativeSaved.get(pending.section) : entrySaved.get(pending.entry);
    return saved && (!pending.configurationKey || saved.configurationKey === pending.configurationKey) ? saved : null;
  }
  function saveFor(pending, items) {
    var record = { configurationKey: pending.configurationKey, items: items, before: pending.before, productId: pending.productId };
    if (pending.configurationKey) nativeSaved.set(pending.section, record); else entrySaved.set(pending.entry, record);
  }
  function recovery(pending, en, ar) {
    resetPending();
    pending.note.textContent = t(en, ar);
    var link = pending.entry.querySelector('[data-klik-express-recovery]');
    if (!link) { link = doc.createElement('a'); link.dataset.klikExpressRecovery = ''; link.className = 'klik-express-cart-link'; pending.entry.append(link); }
    link.href = storefront(root() + 'cart'); link.textContent = t('Review or edit cart', 'راجع السلة أو عدّلها');
  }
  function beginNative(entry, section, button, note, nativeButton, configuration, rememberIntent) {
    if (pendingAdd || nativeButton.disabled) return;
    var getKey = configuration == null ? null : function () { return JSON.stringify(typeof configuration === 'function' ? configuration() : configuration); };
    var key;
    try { key = getKey && getKey(); } catch (_) { note.textContent = t('Review your options and try again.', 'راجع خياراتك وحاول مرة أخرى.'); return; }
    entry.querySelector('[data-klik-express-recovery]')?.remove();
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    note.textContent = t('Checking your cart and selected options…', 'نتحقق من سلتك والخيارات التي اخترتها…');
    var source = section.closest('[data-product-id]') || section;
    var pending = pendingAdd = { button: button, section: section, entry: entry, note: note, configurationKey: key, productId: source.getAttribute('data-product-id'), timer: win.setTimeout(function () {
      if (pendingAdd === pending) recovery(pending, 'Review your cart before trying again; the last addition could not be confirmed.', 'راجع سلتك قبل إعادة المحاولة؛ تعذر تأكيد الإضافة الأخيرة.');
    }, 45000) };
    // This read never writes cart lines. The configurator remains the only writer.
    Promise.resolve(promoPending).catch(function () {}).then(function () { return readCart(); }).then(function (cart) {
      if (pendingAdd !== pending) return;
      if (!button.isConnected || pending.optionsChanged || (getKey && getKey() !== key) || nativeButton.disabled) {
        resetPending(); note.textContent = t('Your options changed. Review them and continue again.', 'تغيرت خياراتك. راجعها ثم تابع من جديد.'); return;
      }
      var saved = savedFor(pending);
      if (saved && !saved.items) {
        var recovered = addedSince(saved, cart);
        if (recovered && matchesAdded(cart, { items: recovered })) { saveFor(pending, recovered); saved = savedFor(pending); }
        else { recovery(pending, 'Your last addition needs a cart review before you add it again.', 'راجع الإضافة الأخيرة في سلتك قبل إضافتها مرة أخرى.'); return; }
      }
      if (saved && matchesAdded(cart, { items: saved.items })) {
        pending.reusing = true; paymentPanel({ items: saved.items }); return;
      }
      if (saved && saved.items.some(function (expected) { return cart.items.some(function (item) { return sameLine(item, expected); }); })) {
        recovery(pending, 'Part of this selection is already in your cart. Review it before adding the complete selection again.', 'جزء من هذا الاختيار موجود في سلتك. راجعه قبل إضافة الاختيار كاملًا مرة أخرى.'); return;
      }
      pending.before = cart;
      if (rememberIntent) rememberNativeIntent(section, cart);
      pending.nativeStarted = true;
      note.textContent = t('Saving your selections and confirming the price…', 'نحفظ اختياراتك ونتحقق من السعر…');
      nativeButton.click();
    }).catch(function () {
      if (pendingAdd === pending) recovery(pending, 'Your cart could not be checked. Try again or review your cart.', 'تعذر التحقق من سلتك. حاول مرة أخرى أو راجع سلتك.');
    });
  }
  function openDialog(added) {
    if (!dialog || typeof dialog.showModal !== 'function') {
      // v2 (K-056): the confirmation sheet instead of a forced /cart load; /cart stays the fallback.
      if (typeof win.KlikCartAdded === 'function') win.KlikCartAdded({ lines: expectedItems(added) || [] }, { family: 'express' });
      else win.location.assign(storefront(root() + 'cart'));
      return false;
    }
    doc.dispatchEvent(new CustomEvent('cart:close'));
    if (!dialog.open) dialog.showModal();
    (dialog.querySelector('#KlikExpressTitle') || dialog.querySelector('[data-klik-express-close]'))?.focus({ preventScroll: true });
    return true;
  }
  function paymentPanel(added, notice) {
    clearIntent();
    var requestId = ++panelRequest, completed = pendingAdd, expected = expectedItems(added);
    if (panelAbort) panelAbort.abort();
    panelAbort = new AbortController(); var signal = panelAbort.signal;
    if (!dialog.open) { returnTarget = completed?.button || doc.activeElement; returnSource = completed?.section || null; }
    if (completed && !completed.reusing) {
      // Remember an uncertain completed attempt, but never treat it as item proof.
      // A canceled/failed review must not silently repeat the native addition.
      saveFor(completed, null);
      completed.note.textContent = t('Added to your cart. Continue when you are ready to pay.', 'أُضيفت إلى سلتك. تابع عندما تكون جاهزًا للدفع.');
    }
    resetPending(); invalidate(); panelSignature = null; panelCart = null;
    // Keep the last review readable while a requested promo total is verified.
    // Its payment controls stay disabled until the replacement is confirmed.
    if (!notice) body.replaceChildren();
    fallback.hidden = true;
    delete dialog.dataset.klikExpressError; fallback.href = storefront(root() + 'cart');
    message('Checking your saved options and total…', 'نتحقق من خياراتك المحفوظة والإجمالي…');
    if (!openDialog(added)) return;
    return Promise.resolve(promoPending).catch(function () {}).then(function () {
      return reviewReads(function () { var native = win.KlikNativeDpoProperties; return native && typeof native.syncCart === 'function' ? native.syncCart() : undefined; },
        function () { return readCart(signal); },
        function () { return request(storefront(root() + 'cart?view=klik-express'), 'text/html', signal).then(function (response) { return response.text(); }); });
    }).then(function (reads) { var cart = reads[0], html = reads[1];
      if (!validCart(cart)) throw new Error('Unpriced or quote item in cart');
      if (!expected && completed) expected = addedSince(completed, cart);
      if ((completed && !expected) || (expected && !matchesAdded(cart, { items: expected }))) throw new Error('Added configuration did not match the saved cart');
      if (completed && !completed.reusing) saveFor(completed, expected);
      if (requestId !== panelRequest || !dialog.open) return;
      return Promise.resolve().then(function () {
        if (requestId !== panelRequest || !dialog.open) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html'), content = parsed.querySelector('[data-klik-express-content]');
        var state = content && content.querySelector('[data-klik-express-cart-state]');
        var displayed = state && JSON.parse(state.textContent);
        if (!validCart(displayed)) throw new Error('Rendered cart is missing or unpriced');
        if (signature(cart) !== signature(displayed)) throw new Error('Rendered cart differs from saved cart');
        return readCart(signal).then(function (latest) {
          if (requestId !== panelRequest || !dialog.open) return;
          // Native cart/property refresh events can occur during this read.
          // Verify the final contents, rather than treating every event as a change.
          if (signature(latest) !== signature(displayed) || codeSignature(latest) !== codeSignature(cart)) throw new Error('Cart changed during payment preparation');
          state.remove();
          body.replaceChildren(doc.importNode(content, true));
          body.querySelectorAll('a[href]').forEach(function (link) { link.href = storefront(link.href); });
          panelSignature = signature(displayed);
          panelCart = latest;
          verified = true; setWallets();
          message('', '');
          renderPromo(latest, notice);
          // A verified review is not checkout or a payment. Reuse the existing
          // consent/preview guards and per-page dedupe; pass no cart/customer data.
          if (dialog.open && win.KlikJourney && typeof win.KlikJourney.track === 'function') {
            try { win.KlikJourney.track('klik_payment_review'); } catch (_) { /* Analytics must not interrupt payment. */ }
          }
        });
      });
    }).catch(function (error) {
      if (requestId !== panelRequest || !dialog.open) return;
      dialog.dataset.klikExpressError = error.message;
      verified = false; setWallets(); fallback.hidden = false;
      message('Your cart needs a quick review. Open it to check the items and continue to payment.', 'تحتاج سلتك إلى مراجعة سريعة. افتحها لمراجعة القطع والمتابعة إلى الدفع.');
    });
  }
  function campaignCode() {
    var config;
    try { config = JSON.parse(doc.querySelector('[data-kc-config]')?.textContent || 'null'); } catch (_) { return null; }
    if (!config || config.enabled !== true || !/^[A-Za-z0-9_-]{3,32}$/.test(config.code || '')) return null;
    var now = Date.now(), start = Date.parse(config.start), end = config.end === null ? Infinity : Date.parse(config.end);
    return Number.isFinite(start) && (Number.isFinite(end) || end === Infinity) && start < end && now >= start && now < end ? config.code : null;
  }
  function promoMessage(en, ar, error, scope) {
    var output = (scope || body).querySelector('[data-klik-express-promo-status]');
    if (!output) return;
    output.textContent = t(en, ar); output.dataset.error = error ? 'true' : 'false';
  }
  function renderPromo(cart, notice, scope) {
    scope = scope || body;
    function notifyPromo(en, ar, error) { promoMessage(en, ar, error, scope); }
    var container = scope.querySelector('[data-klik-express-promos]'), input = scope.querySelector('[data-klik-express-promo-input]');
    if (!container || !input) return;
    var codes = discountCodes(cart);
    input.removeAttribute('aria-invalid');
    container.replaceChildren();
    var onChip = scope.hasAttribute('data-klik-cart-promo') ? discountApplications(cart).filter(function (entry) { return entry.type === 'discount_code' && Number(entry.total_allocated_amount) > 0; }).map(function (entry) { return String(entry.title).toLowerCase(); }) : [];
    codes.forEach(function (entry) {
      if (entry.applicable && onChip.indexOf(entry.code.toLowerCase()) >= 0) return;
      var pill = doc.createElement('li'), code = doc.createElement('bdi'), label = doc.createElement('span'), remove = doc.createElement('button');
      code.textContent = entry.code; code.setAttribute('data-wg-notranslate', '');
      label.textContent = entry.applicable ? t('applied', 'مطبّق') : t('not applied', 'غير مطبّق');
      remove.type = 'button'; remove.dataset.klikExpressPromoRemove = entry.code;
      remove.textContent = t('Remove', 'إزالة'); remove.setAttribute('aria-label', t('Remove code ', 'إزالة الرمز ') + entry.code);
      pill.append(code, label, remove); container.append(pill);
    });
    var suggestion = scope.querySelector('[data-klik-express-promo-campaign]'), current = campaignCode();
    if (suggestion) {
      suggestion.hidden = !current || codes.some(function (entry) { return entry.code.toLowerCase() === current.toLowerCase() && entry.applicable; });
      if (current) { suggestion.dataset.klikExpressPromoCampaign = current; suggestion.textContent = t('Apply ', 'تطبيق ') + current; }
    }
    if (!notice) return;
    var applied = codes.find(function (entry) { return entry.code.toLowerCase() === notice.code.toLowerCase(); });
    if (notice.changed) {
      notifyPromo('Your cart changed. Review the updated items and total, then apply your code again.', 'تغيرت سلتك. راجع القطع والإجمالي المحدّث، ثم طبّق الرمز من جديد.', true);
      input.value = notice.action === 'apply' ? notice.code : '';
    } else if (notice.action === 'remove' && !applied) {
      notifyPromo('Code removed. Review your updated total before payment.', 'تمت إزالة الرمز. راجع الإجمالي المحدّث قبل الدفع.');
    } else if (notice.action === 'apply' && applied && applied.applicable) {
      var allocated = discountApplications(cart).some(function (entry) { return entry.type === 'discount_code' && String(entry.title).toLowerCase() === notice.code.toLowerCase() && Number(entry.total_allocated_amount) > 0; });
      if (allocated) notifyPromo('Promo applied. Review your updated total before payment.', 'تم تطبيق الخصم. راجع الإجمالي المحدّث قبل الدفع.');
      else notifyPromo('Code accepted. Any shipping discount is confirmed at checkout.', 'تم قبول الرمز. يُؤكّد خصم الشحن، إن وُجد، عند إتمام الطلب.');
    } else {
      input.value = notice.action === 'apply' ? notice.code : '';
      input.setAttribute('aria-invalid', notice.action === 'apply' && !notice.network ? 'true' : 'false');
      if (notice.network) notifyPromo('We could not confirm the promo update. Check the codes and total shown, then try again if needed.', 'تعذر تأكيد تحديث الخصم. راجع الرموز والإجمالي المعروض، ثم حاول مرة أخرى إذا لزم الأمر.', true);
      else if (notice.action === 'remove') notifyPromo('This code is still present. Try removing it again or review your cart.', 'ما زال الرمز موجودًا. حاول إزالته مرة أخرى أو راجع سلتك.', true);
      else notifyPromo('This code cannot be applied to this cart. Check the spelling, offer terms or other codes already applied.', 'لا يمكن تطبيق هذا الرمز على السلة الحالية. تحقق من كتابته وشروط العرض والرموز المطبّقة الأخرى.', true);
    }
    // The form is replaced with the new native total and an unchecked terms box.
    // Keep the shopper at the result without opening a wallet or submitting checkout.
    scope.querySelector('[data-klik-express-promo-status]')?.focus({ preventScroll: true });
  }
  function applyPromo(code, action) {
    if (promoPending || !dialog.open || !verified || !panelCart) return;
    code = String(code || '').trim(); action = action === 'remove' ? 'remove' : 'apply';
    var input = body.querySelector('[data-klik-express-promo-input]');
    if (!code || code.length > 255 || /[,\u0000-\u001f\u007f]/.test(code)) {
      input?.setAttribute('aria-invalid', 'true');
      promoMessage('Enter one promo code, then select Apply.', 'أدخل رمز خصم واحدًا، ثم اضغط تطبيق.', true); input?.focus(); return;
    }
    var requestId = panelRequest, before = panelCart, snapshot = panelSignature;
    var existing = discountCodes(before);
    if (action === 'apply' && existing.some(function (entry) { return entry.code.toLowerCase() === code.toLowerCase() && entry.applicable; })) {
      promoMessage('This code is already applied. Review the total below.', 'هذا الرمز مطبّق بالفعل. راجع الإجمالي أدناه.'); return;
    }
    invalidate();
    body.querySelectorAll('.cart__terms-checkbox').forEach(function (box) { box.checked = false; });
    body.querySelectorAll('[data-klik-express-promo-input], [data-klik-express-promo-apply], [data-klik-express-promo-remove], [data-klik-express-promo-campaign]').forEach(function (control) { control.disabled = true; });
    body.querySelector('[data-klik-express-promo]')?.setAttribute('aria-busy', 'true');
    promoMessage('Checking your code and updating the total…', 'نتحقق من الرمز ونحدّث الإجمالي…');
    // Discount updates never send line items, quantities, properties or notes.
    // Serialize through the server response: aborting a POST cannot undo a saved code.
    var mutation = readCart().then(function (latest) {
      if (signature(latest) !== snapshot || codeSignature(latest) !== codeSignature(before)) return { changed: true };
      return request(root() + 'cart/update.js', null, null, { discount: promoCodesAfter(latest, code, action) }).then(function (response) { return response.json(); }).then(function () { return {}; });
    }).catch(function () { return { network: true }; });
    promoPending = mutation; setWallets();
    mutation.then(function (result) {
      if (promoPending === mutation) promoPending = null;
      if (requestId !== panelRequest || !dialog.open) { scheduleRefresh(); return; }
      paymentPanel(null, { code: code, action: action, network: result.network, changed: result.changed });
    });
  }
  function renderCartPromos(cart) {
    doc.querySelectorAll('[data-klik-cart-promo]').forEach(function (scope) {
      var notice = cartPromoNotice && cartPromoNotice.sourceId === scope.id ? cartPromoNotice : null;
      if (scope.dataset.codeSignature !== codeSignature(cart) || notice) {
        renderPromo(cart, notice, scope); scope.dataset.codeSignature = codeSignature(cart);
        if (notice) {
          var holder = scope.closest('details');
          if (holder) holder.open = true;
          scope.querySelector('[data-klik-express-promo-status]')?.scrollIntoView({ block: 'nearest' });
        }
      }
    });
    cartPromoNotice = null;
  }
  function applyCartPromo(code, action, scope) {
    if (promoPending) return;
    code = String(code || '').trim(); action = action === 'remove' ? 'remove' : 'apply';
    var input = scope.querySelector('[data-klik-express-promo-input]');
    if (!code || code.length > 255 || /[,\u0000-\u001f\u007f]/.test(code)) {
      input?.setAttribute('aria-invalid', 'true');
      promoMessage('Enter one promo code, then select Apply.', 'أدخل رمز خصم واحدًا، ثم اضغط تطبيق.', true, scope); input?.focus(); return;
    }
    var controls = [];
    doc.querySelectorAll('#CartPageForm input, #CartPageForm button, #CartPageForm textarea, #CartPageForm select, #CartDrawerForm input, #CartDrawerForm button, #CartDrawerForm textarea, #CartDrawerForm select').forEach(function (control) {
      controls.push([control, control.disabled]); control.disabled = true;
    });
    scope.setAttribute('aria-busy', 'true'); invalidate();
    promoMessage('Checking your code and updating the total…', 'نتحقق من الرمز ونحدّث الإجمالي…', false, scope);
    // Reload the native cart after the discount-only update. This refreshes line
    // keys, rendered prices and Shopify wallet components together.
    var mutation = readCart().then(function (cart) {
      if (!currentNote(cart)) return { notePending: true };
      if (action === 'apply' && discountCodes(cart).some(function (entry) { return entry.code.toLowerCase() === code.toLowerCase() && entry.applicable; })) return { already: true, cart: cart };
      return request(root() + 'cart/update.js', null, null, { discount: promoCodesAfter(cart, code, action) }).then(function (response) { return response.json(); }).then(function () { return {}; });
    }).catch(function () { return { network: true }; });
    promoPending = mutation; setWallets();
    mutation.then(function (result) {
      if (result.already || result.notePending) {
        promoPending = null; controls.forEach(function (saved) { saved[0].disabled = saved[1]; }); scope.removeAttribute('aria-busy');
        if (result.already) { renderPromo(result.cart, null, scope); promoMessage('This code is already applied. Review the total below.', 'هذا الرمز مطبّق بالفعل. راجع الإجمالي أدناه.', false, scope); }
        else promoMessage('Your order note is still saving. Wait a moment, then apply your code again.', 'لا تزال ملاحظة الطلب قيد الحفظ. انتظر قليلًا ثم طبّق الرمز من جديد.', true, scope);
        scheduleRefresh(); return;
      }
      try { win.sessionStorage.setItem(cartPromoNoticeKey, JSON.stringify({ code: code, action: action, network: !!result.network, sourceId: scope.id, at: Date.now() })); } catch (_) {}
      // Keep payment and edit controls blocked until the new page is ready.
      win.location.reload();
    });
  }
  api.isPendingFor = function (section) { return !!(pendingAdd && pendingAdd.section === section); };
  api.completeNativeSet = function (section, added) {
    if (!pendingAdd || pendingAdd.section !== section) return false;
    // Called only after the existing set integration resolves its verified add.
    paymentPanel(added);
    return true;
  };
  api.completeNativeOrder = api.completeNativeSet;
  api.failNativeOrder = function (section) {
    if (!api.isPendingFor(section)) return false;
    var note = pendingAdd.note; clearIntent(); resetPending();
    note.textContent = t('Review the highlighted options and try again.', 'راجع الخيارات المحددة وحاول مرة أخرى.');
    return true;
  };
  api.mountNativeReview = function (review, source, nativeButton, configuration) {
    if (!PDP_PAYMENT_ENTRY) return;
    if (!review || !source || !nativeButton || review.querySelector('[data-klik-express-entry]')) return;
    var entry = doc.createElement('div'), button = doc.createElement('button'), note = doc.createElement('p');
    entry.className = 'klik-express-entry'; entry.dataset.klikExpressEntry = '';
    button.type = 'button'; button.className = 'btn btn--full'; button.disabled = nativeButton.disabled;
    button.textContent = t('Continue to payment', 'المتابعة إلى الدفع');
    note.textContent = t('Review your total, then choose Apple Pay if available or another payment method.', 'راجع الإجمالي، ثم اختر Apple Pay إذا كان متاحًا أو طريقة دفع أخرى.');
    note.setAttribute('role', 'status'); entry.append(button, note); review.prepend(entry);
    button.addEventListener('click', function () {
      beginNative(entry, source, button, note, nativeButton, configuration, false);
    });
  };
  function mountEntries(scope) {
    (scope || doc).querySelectorAll('[data-klik-dpo-review]').forEach(function (review) {
      if (review.querySelector('[data-klik-express-entry]')) return;
      var section = review.closest('[data-section-type="product"], [id^="ProductSection-"]');
      if (!section || section.getAttribute('data-product-handle') === 'fully-custom-order') return;
      var nativeButton = section.querySelector('[dpo_add2cart], [data-dpo-gated-submit]');
      if (!nativeButton) return;
      var entry = doc.createElement('div'), button = doc.createElement('button'), note = doc.createElement('p');
      entry.className = 'klik-express-entry'; entry.dataset.klikExpressEntry = '';
      button.type = 'button'; button.className = 'btn btn--full'; button.textContent = t('Continue to payment', 'المتابعة إلى الدفع');
      note.textContent = t('Review your total, then choose Apple Pay if available or another payment method.', 'راجع الإجمالي، ثم اختر Apple Pay إذا كان متاحًا أو طريقة دفع أخرى.');
      note.setAttribute('role', 'status'); entry.append(button, note); review.prepend(entry);
      button.addEventListener('click', function () {
        if (pendingAdd) return;
        nativeButton = section.querySelector('[dpo_add2cart], [data-dpo-gated-submit]');
        if (!nativeButton || nativeButton.disabled) {
          note.textContent = t('Complete the highlighted options before continuing.', 'أكمل الخيارات المطلوبة قبل المتابعة.'); return;
        }
        beginNative(entry, section, button, note, nativeButton, null, true);
      });
      section.addEventListener('change', function (event) {
        if (event.target.closest('[data-klik-express-entry]')) return;
        if (pendingAdd && pendingAdd.section === section && !pendingAdd.nativeStarted) pendingAdd.optionsChanged = true;
        if (!pendingAdd) entrySaved.delete(entry);
      });
    });
  }
  var observedSections = new WeakSet();
  function installEntries(scope) {
    if (!PDP_PAYMENT_ENTRY) return;
    scope = scope && scope.querySelectorAll ? scope : doc;
    mountEntries(scope);
    scope.querySelectorAll('[data-klik-dpo-review]').forEach(function (review) {
      if (review.querySelector('[data-klik-express-entry]')) return;
      var section = review.closest('[data-section-type="product"], [id^="ProductSection-"]');
      if (!section || observedSections.has(section)) return;
      observedSections.add(section);
      // DPO can insert its native control asynchronously. Observe only this
      // product, and stop as soon as the entry exists (or initialization ends).
      var observer = new MutationObserver(function () {
        mountEntries(section);
        if (review.querySelector('[data-klik-express-entry]')) { observer.disconnect(); win.clearTimeout(timeout); }
      });
      observer.observe(section, { childList: true, subtree: true });
      var timeout = win.setTimeout(function () { observer.disconnect(); }, 15000);
    });
  }
  function start() {
    dialog = doc.querySelector('[data-klik-express-dialog]'); if (!dialog) return;
    try {
      var savedPromo = JSON.parse(win.sessionStorage.getItem(cartPromoNoticeKey));
      win.sessionStorage.removeItem(cartPromoNoticeKey);
      if (savedPromo && Number.isFinite(savedPromo.at) && Date.now() - savedPromo.at >= 0 && Date.now() - savedPromo.at < 120000 && typeof savedPromo.code === 'string' && ['apply', 'remove'].indexOf(savedPromo.action) >= 0) cartPromoNotice = savedPromo;
    } catch (_) {}
    body = dialog.querySelector('[data-klik-express-body]'); status = dialog.querySelector('[data-klik-express-status]'); fallback = dialog.querySelector('[data-klik-express-fallback]');
    dialog.querySelector('[data-klik-express-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      panelRequest += 1; if (panelAbort) panelAbort.abort(); panelAbort = null; panelSignature = null; panelCart = null;
      body.replaceChildren(); invalidate(); refresh();
      var target = returnTarget?.isConnected ? returnTarget : returnSource?.querySelector('[data-klik-express-entry] button');
      if (target && !target.disabled && !target.closest('[hidden],[inert]')) target.focus({ preventScroll: true });
      returnTarget = null; returnSource = null;
    });
    doc.addEventListener('change', function (event) {
      if (event.target.matches('.cart__terms-checkbox')) { setWallets(); if (!verified) refresh(); }
      else if (event.target.closest('#CartPageForm, #CartDrawerForm') && !event.target.closest('[data-klik-express-promo]')) scheduleRefresh();
    });
    doc.addEventListener('input', function (event) { if (event.target.closest('#CartPageForm, #CartDrawerForm') && !event.target.closest('[data-klik-express-promo]')) scheduleRefresh(); });
    doc.addEventListener('submit', function (event) {
      if (event.target.matches('#CartPageForm, #CartDrawerForm')) {
        if (doc.activeElement?.matches('[data-klik-express-promo-input]')) {
          event.preventDefault(); event.stopImmediatePropagation(); applyCartPromo(doc.activeElement.value, 'apply', doc.activeElement.closest('[data-klik-cart-promo]')); return;
        }
        if (promoPending) { event.preventDefault(); event.stopImmediatePropagation(); }
        return;
      }
      if (event.target.id !== 'KlikExpressCartForm') return;
      if (doc.activeElement?.matches('[data-klik-express-promo-input]')) { event.preventDefault(); event.stopImmediatePropagation(); applyPromo(doc.activeElement.value); return; }
      if (!verified || promoPending || !termsAccepted(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); setWallets(); }
    }, true);
    doc.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.matches('[data-klik-express-promo-input]')) return;
      event.preventDefault(); event.stopPropagation();
      var scope = event.target.closest('[data-klik-cart-promo]');
      if (scope) applyCartPromo(event.target.value, 'apply', scope); else applyPromo(event.target.value);
    });
    doc.addEventListener('click', function (event) {
      var button = event.target.closest('[data-klik-express-promo-apply], [data-klik-express-promo-remove], [data-klik-express-promo-campaign]');
      if (!button) return;
      event.preventDefault();
      var form = button.closest('form');
      var scope = button.closest('[data-klik-express-promo]') || (form && form.querySelector('[data-klik-cart-promo]'));
      if (!scope) return;
      function apply(code, action) { if (scope.hasAttribute('data-klik-cart-promo')) applyCartPromo(code, action, scope); else applyPromo(code, action); }
      if (button.hasAttribute('data-klik-express-promo-remove')) apply(button.dataset.klikExpressPromoRemove, 'remove');
      else if (button.hasAttribute('data-klik-express-promo-campaign')) {
        var current = campaignCode();
        if (current) apply(current); else { button.hidden = true; promoMessage('This offer is no longer available. You can enter another code.', 'هذا العرض لم يعد متاحًا. يمكنك إدخال رمز آخر.', true, scope); }
      } else apply(scope.querySelector('[data-klik-express-promo-input]')?.value);
    });
    doc.addEventListener('ajaxProduct:added', function (event) {
      if (pendingAdd && pendingAdd.nativeStarted) {
        var detail = event.detail || {}, source = detail.addToCartBtn;
        if (!source || pendingAdd.section.contains(source)) { paymentPanel(detail.product); return; }
      }
      scheduleRefresh();
    });
    doc.addEventListener('ajaxProduct:error', function () { if (pendingAdd) { var note = pendingAdd.note; resetPending(); note.textContent = t('Review the highlighted options and try again.', 'راجع الخيارات المحددة وحاول مرة أخرى.'); } });
    // K-113 (request from bugs-nav): the cart is read only where its promo, wallets or review are on screen (the cart page,
    // the open drawer, the review dialog), never on a plain collection or product view with the drawer closed. A closed
    // drawer is refreshed when it opens.
    function cartInView() {
      return !!(doc.getElementById('CartPageForm') || doc.querySelector('#CartDrawer.drawer--is-open') || (dialog && dialog.open) || /\/cart\/?$/.test(win.location.pathname));
    }
    function refreshIfShown() { if (cartInView()) scheduleRefresh(); else invalidate(); }
    ['cart:updated', 'cart:build'].forEach(function (name) { doc.addEventListener(name, refreshIfShown); });
    ['cart:open', 'drawerOpen.CartDrawer'].forEach(function (name) { doc.addEventListener(name, scheduleRefresh); });
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) invalidate(); else refreshIfShown(); });
    win.addEventListener('pageshow', refreshIfShown);
    doc.addEventListener('shopify:section:load', function (event) { installEntries(event.target); });
    installEntries(doc); if (cartInView()) refresh(); resumeNativeIntent();
  }
  api.open = paymentPanel;
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}(typeof window === 'undefined' ? null : window));
